import { render, staticRenderFns } from "./ad-card.vue?vue&type=template&id=24db0648&"
import script from "./ad-card.vue?vue&type=script&lang=js&"
export * from "./ad-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports